var _ = "p273__ReoPopup-8045_fc591d987__12i5po5b", p = "p273__ReoPopup-8045_fc591d987__12i5po59", o = { article: "p273__ReoPopup-8045_fc591d987__article__12i5po56 p273__ReoPopup-8045_fc591d987__12i5po55", form: "p273__ReoPopup-8045_fc591d987__form__12i5po57 p273__ReoPopup-8045_fc591d987__12i5po55" }, c = "p273__ReoPopup-8045_fc591d987__12i5po5c", e = "p273__ReoPopup-8045_fc591d987__12i5po58", i = { article: "p273__ReoPopup-8045_fc591d987__article__12i5po53 p273__ReoPopup-8045_fc591d987__12i5po52", form: "p273__ReoPopup-8045_fc591d987__form__12i5po54 p273__ReoPopup-8045_fc591d987__12i5po52" }, f = "p273__ReoPopup-8045_fc591d987__12i5po5d", u = "p273__ReoPopup-8045_fc591d987__12i5po51", a = "p273__ReoPopup-8045_fc591d987__12i5po50", d = "p273__ReoPopup-8045_fc591d987__12i5po5a";
export {
  _ as body,
  p as closeIcon,
  o as content,
  c as footer,
  e as iconWrap,
  i as popup,
  f as popupScrollBar,
  u as popupWrap,
  a as reoPopupRoot,
  d as title
};
//# sourceMappingURL=ReoPopup.mjs.map
